export default {
  data() {
    return {
      sliderMax: 360,
      sliderPercentMax: 100,
      collapseActiveNames: ["8"],
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          src: require("../../../../../assets/images/solid-1.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          src: require("../../../../../assets/images/dashed-1.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          src: require("../../../../../assets/images/dotted-1.png")
        }
      ],
      fontFamilyList: Object.freeze([
        {
          title: "默认字体",
          value: "sans-serif",
          img: require(`@/assets/images/fontImages/默认字体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "钉钉进步体",
          value: "钉钉进步体",
          img: require(`@/assets/images/fontImages/钉钉进步体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "方正清刻本悦宋简体",
          value: "方正",
          img: require(`@/assets/images/fontImages/方正清刻本悦宋简体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "方正正大黑简体",
          value: "方正正大黑简体",
          img: require(`@/assets/images/fontImages/方正正大黑简体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "联想小新潮酷体",
          value: "联想小新潮酷体",
          img: require(`@/assets/images/fontImages/联想小新潮酷体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "庞门正道标题体",
          value: "庞门正道标题",
          img: require(`@/assets/images/fontImages/庞门正道标题体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "思源黑体",
          value: "SourceHanSansCN",
          img: require(`@/assets/images/fontImages/思源黑体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "思源宋体",
          value: "SourceHanSerifCN",
          img: require(`@/assets/images/fontImages/思源宋体${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          title: "优设标题黑",
          value: "YouSheBiaoTiHei",
          img: require(`@/assets/images/fontImages/优设标题黑${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            }
          ]
        },
        {
          title: "Alata",
          value: "Alata",
          img: require(`@/assets/images/fontImages/Alata${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            }
          ]
        },
        {
          title: "D-din",
          value: "D-din",
          img: require(`@/assets/images/fontImages/D-din${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "D-din Condensed",
          value: "D-din Condensed",
          img: require(`@/assets/images/fontImages/D-DIN-Condensed${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "D-din Exp",
          value: "D-din Exp",
          img: require(`@/assets/images/fontImages/D-DIN-Exp${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            }
          ]
        },
        {
          title: "Raleway",
          value: "Raleway",
          img: require(`@/assets/images/fontImages/Raleway${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "Roboto-Regular",
          value: "Roboto-Regular",
          img: require(`@/assets/images/fontImages/Roboto-Regular${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        },
        {
          label: "Roboto-Black",
          value: "Roboto-Black",
          img: require(`@/assets/images/fontImages/Roboto-Black${this.request_prefix === "bigScreen" ? '_bigScreen' : ''}.png`),
          fontWeightList: [
            {
              title: "细体",
              value: 200
            },
            {
              title: "常规体",
              value: 400
            },
            {
              title: "粗体",
              value: 600
            },
            {
              title: "加粗体",
              value: 900
            }
          ]
        }
      ]),
      // fontFamilyList: [
      //   {
      //     label: "默认字体",
      //     value: "sans-serif"
      //   },
      //   {
      //     label: "钉钉进步体",
      //     value: "钉钉进步体"
      //   },
      //   {
      //     label: "方正",
      //     value: "方正"
      //   },
      //   {
      //     label: "方正正大黑简体",
      //     value: "方正正大黑简体"
      //   },
      //   {
      //     label: "联想小新潮酷体",
      //     value: "联想小新潮酷体"
      //   },
      //   {
      //     label: "庞门正道标题",
      //     value: "庞门正道标题"
      //   },
      //   {
      //     label: "思源黑体",
      //     value: "SourceHanSansCN"
      //   },
      //   {
      //     label: "思源宋体",
      //     value: "SourceHanSerifCN"
      //   },
      //   {
      //     label: "优设标题黑",
      //     value: "YouSheBiaoTiHei"
      //   },
      //   {
      //     label: "Alata",
      //     value: "Alata"
      //   },
      //   {
      //     label: "D-din",
      //     value: "D-din"
      //   },
      //   {
      //     label: "D-din Condensed",
      //     value: "D-din Condensed"
      //   },
      //   {
      //     label: "D-din Exp",
      //     value: "D-din Exp"
      //   },
      //   {
      //     label: "Raleway",
      //     value: "Raleway"
      //   },
      //   {
      //     label: "Roboto-Regular",
      //     value: "Roboto-Regular"
      //   },
      //   {
      //     label: "Roboto-Black",
      //     value: "Roboto-Black"
      //   }
      // ],
      positionList1: [
        {
          title: "上",
          label: "top"
        },
        {
          title: "下",
          label: "bottom"
        },
        {
          title: "中",
          label: "middle"
        }
      ],
      positionList2: [
        {
          title: "居左",
          label: "left"
        },
        {
          title: "居中",
          label: "center"
        },
        {
          title: "居右",
          label: "right"
        }
      ],
      legendOrientList: [
        {
          title: "左右排列",
          label: "horizontal"
        },
        {
          title: "上下排列",
          label: "vertical"
        }
      ],

      fontWeightList: [
        {
          title: "细体",
          value: 200
        },
        {
          title: "常规体",
          value: 400
        },
        {
          title: "粗体",
          value: 600
        },
        {
          title: "加粗体",
          value: 900
        }
      ],
      animateDurTime: 1,
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ]
    }
  }
}
